export const OFFLINE_CAPABLE_PATHS: ReadonlySet<string> = new Set([
  '/',
  '/operations',
  '/stoppages',
  '/production/list',
  '/production/show',
  '/production/rehandle',
  '/production/crushing',
  '/db/bh-drilling',
  '/db/rc-drilling',
  '/db/explosives',
  '/db/consumables',
])

const OFFLINE_CAPABLE_ROUTES: readonly RegExp[] = [
  /^\/db\/blasts\/pattern\/\d+$/,
]

export const isOfflineCapable = (pathname: string) =>
  OFFLINE_CAPABLE_PATHS.has(pathname) || OFFLINE_CAPABLE_ROUTES.some(route => route.test(pathname))
